import { render, staticRenderFns } from "./CustomerImportModal.vue?vue&type=template&id=39b139d1"
import script from "./CustomerImportModal.vue?vue&type=script&lang=js"
export * from "./CustomerImportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports